import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import endpointList from "../../config/endpointList.jsx";

export const fetchColors = createAsyncThunk(
    'colors/fetchColors',
    async () => {
        const response = await fetch(endpointList.getColors);
        const data = await response.json();
        return data;
    }
);

const colorsSlice = createSlice({
    name: 'colors',
    initialState: {
        Colors: [],
        status: 'idle',
        error: null,
        isLoaded: false,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchColors.pending, (state) => {
                state.status = 'loading';
                state.isLoaded = false;
            })
            .addCase(fetchColors.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.Colors = action.payload.data;
                state.isLoaded = true;
            })
            .addCase(fetchColors.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
                state.isLoaded = false;
            });
    },
});

export default colorsSlice.reducer;
